<template>
  <div class="ModalNewEntities">
    <a-button type="primary" class="button--create" @click="handleShowModal">
      Crear nueva empresa
    </a-button>
    <a-modal
      :visible="visible"
      title="Crear nueva empresa"
      width="600px"
      centered
      :mask-closable="false"
      :keyboard="false"
      @cancel="handleConfirmationClose"
    >
      <div ref="scrollWrapper">
        <CustomScrollbar height="500px">
        <a-form class="form" layout="vertical" ref="formRef" :model="formState" :rules="rules">
          <image-picker
            :value="imageFile"
            @update:value="imageFile = $event"
            :src="imageDefault"
            @onSelectedImage="handleSelectedImagen"
            :selectedImage="selectedImage"
            @onSelectedImageEntity="handleSelectedImagenEntity"
            :isEntity="isEntity"
          />

          <a-form-item label="Nombre de la empresa" name="name">
            <a-input
              v-model:value="formState.name"
              placeholder="Escribir nombre de la empresa"
              @input="showConfirmModal = true"
            />
          </a-form-item>

          <a-form-item label="Industria" name="type_industry">
            <a-select
              v-model:value="formState.type_industry"
              placeholder="Seleccione tipo de industria"
              @change="showConfirmModal = true"
              @dropdownVisibleChange="handleDropdownVisibleChange"
            >
              <a-select-option
                v-for="industry in industries"
                :key="industry.id"
                :value="industry.id"
              >
                {{ industry.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item label="Teléfono de contacto" name="phone">
                <a-row :gutter="20" type="flex">
                  <a-col>
                    <SelectorCountry :code="codePhone" @selected="codePhone = $event; showConfirmModal = true" @dropdownVisibleChange="handleDropdownVisibleChange" class="country" />

                    <!-- <a-select
                      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                      v-model:value="codePhone"
                      show-search
                      :filter-option="false"
                      :not-found-content="null"
                      placeholder="Selecciona el código del país"
                      @search="filterCountries"
                      @dropdownVisibleChange="handleChange"
                      @change="showConfirmModal = true"
                      style="width: 140px"
                    >
                      <a-select-option v-for="country in countriesCode" :key="country.id">
                        <div v-show="!showCountry" :style="{ color: '#bfbfbf' }" class="country">
                          <img class="flag" :src="country.url_flag" alt="pais" /> +
                          <span>{{ country.code_phone }}</span>
                        </div>
                        <div v-show="showCountry" :style="{ color: '' }" class="country">
                          <img class="flag" :src="country.url_flag" alt="pais" />
                          <span>{{ country.name }}</span> +
                          <span>{{ country.code_phone }}</span>
                        </div>
                      </a-select-option>
                    </a-select> -->
                  </a-col>
                  <a-col flex="1">
                    <a-input
                      v-model:value="formState.phone"
                      placeholder="Número de teléfono"
                      @input="showConfirmModal = true"
                    />
                  </a-col>
                </a-row>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="24">
              <a-form-item name="countryCity">
                <template #label>
                  <span>
                    País de la empresa
                    <a-tooltip>
                      <InfoCircleOutlined />
                      <template #title>
                        <span class="info-circle">
                          Selecciona el país principal donde se ubica esta empresa
                        </span>
                      </template>
                    </a-tooltip>
                  </span>
                </template>
                <a-select
                  v-model:value="formState.countryCity"
                  show-search
                  :filter-option="false"
                  :not-found-content="null"
                  placeholder="Seleccionar país"
                  @search="searchCountries"
                  @dropdownVisibleChange="handleChangeCountry"
                  @change="showConfirmModal = true"
                  @keypress="handleSearchCountry($event)"
                >
                  <a-select-option v-for="country in allCountries" :key="country.id">
                    <div>
                      <img class="flag" :src="country.url_flag" alt="pais" />
                      <span> {{ country.name }}</span>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item label="Email" name="email">
            <a-input
              v-model:value="formState.email"
              placeholder="Escribir correo de la empresa"
              @input="showConfirmModal = true"
            />
          </a-form-item>

          <AIEntityPromptInput
            v-if="hasAIIntegration"
            v-model:value="formState.description"
            v-model:keywords="formState.keywords"
          />
        </a-form>
        </CustomScrollbar>
      </div>

      <!-- <div style="text-align: center; margin-top: -15px">
        <a-space :size="8" class="info-section" align="start">
          <InfoCircleOutlined />

          <span>
            Al crear esta empresa, automáticamente se generará y asociará una campaña. Por defecto,
            su tipo de operación será de “Atención al Cliente”. Se podrá modificar su configuración
            en la sección de "Campañas".
          </span>
        </a-space>
      </div> -->

      <!-- Fotter Modal -->
      <template v-slot:footer>
        <a-button key="back" @click="handleConfirmationClose"> Cancelar </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
          Crear empresa
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import ImagePicker from "@/app/shared/components/molecules/ImagePicker.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { defineComponent, ref, reactive, toRaw, createVNode, computed, watch } from "vue";
import { InfoCircleOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";
import { useStore } from "vuex";
import AIEntityPromptInput from "@/app/integrations/components/inputs/AIEntityPromptInput.vue";
import briefCaseBlue from "@/app/entities/assets/briefcase-blue.svg?url";
import SelectorCountry from "@/app/shared/components/selectors/SelectorCountry.vue";

export default defineComponent({
  components: {
    ImagePicker,
    CustomScrollbar,
    InfoCircleOutlined,
    AIEntityPromptInput,
    SelectorCountry,
  },
  setup() {
    const formRef = ref();
    const visible = ref(false);
    const loading = ref(false);
    const codePhone = ref();
    const country = ref(undefined);
    const imageFile = ref(undefined);
    const showConfirmModal = ref(false);
    const showCountry = ref(false);
    const showCountries = ref(false);
    const selectedImage = ref(false);
    const isEntity = ref(true);
    const store = useStore();
    const countries = computed(() => store.getters["getAllCountries"]);
    const getDataUser = computed(() => store.getters["getDataUser"]);
    const countriesCode = ref([]);
    const allCountries = ref([]);
    const formState = reactive({
      name: undefined,
      phone: undefined,
      email: undefined,
      type_industry: undefined,
      countryCity: getDataUser.value?.customer?.country,
      description: undefined,
      keywords: [],
    });
    const rules = {
      name: [{ required: true, message: "Campo requerido" }],
      type_industry: [{ required: true, message: "Campo requerido" }],
    };
    const handleConfirmationClose = () => {
      if (showConfirmModal.value) {
        Modal.confirm({
          title: "¿Estás seguro de descartar cambios?",
          content: "Al cerrar no se guardarán los datos previamente ingresados",
          icon: createVNode(QuestionCircleOutlined),
          onOk: () => handleCancel(),
          centered: true,
          okText: "Sí, descartar cambios",
          cancelText: "No, seguir editando",
        });
      } else {
        handleCancel();
      }
    };
    const handleCancel = () => {
      resetFields();
      visible.value = false;
      showConfirmModal.value = false;
      selectedImage.value = false;
    };
    const resetFields = () => {
      formRef.value.resetFields();
      loading.value = false;
      codePhone.value = undefined;
      imageFile.value = undefined;
      country.value = undefined;
    };
    watch(countries, (newValue) => {
      countriesCode.value = newValue;
    });
    watch(countries, (newValue) => {
      allCountries.value = newValue;
    });
    return {
      formRef,
      formState,
      rules,
      handleConfirmationClose,
      handleCancel,
      visible,
      resetFields,
      loading,
      codePhone,
      imageFile,
      showConfirmModal,
      country,
      showCountry,
      countries,
      countriesCode,
      allCountries,
      showCountries,
      selectedImage,
      isEntity,
    };
  },
  data() {
    return {
      description: "",
      maxObservation: 120, // Máxima cantidad de caracteres en el campo de "Observación del cliente"
      isAnyDropdownOpen: false,
      dropdownCloseTimer: null,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.scrollWrapper?.addEventListener("wheel", this.preventScroll, { capture: true, passive: false });
        });
      } else {
        this.$refs.scrollWrapper?.removeEventListener("wheel", this.preventScroll, { capture: true });
      }
    },
  },
  created() {
    this.$store.dispatch("fetchAllCountries");
  },
  computed: {
    industries() {
      return this.$store.getters["getAllIndustries"];
    },
    imageDefault() {
      let url = "";
      url = briefCaseBlue;
      return url;
    },
    hasAIIntegration() {
      const user = this.$store.getters["getDataUser"];

      return user.customer_enable_summary;
    },
  },
  methods: {
    handleSearchCountry(e) {
      const char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z]+$/.test(char)) return true;
      else e.preventDefault();
    },
    filterCountries(value) {
      value = value.toLowerCase();
      this.countriesCode = this.countries.filter((item) => {
        return (
          // item.name.toLowerCase().includes(value) || item.code_phone.toLowerCase().includes(value)
          item.name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .includes(value) || item.code_phone.toLowerCase().includes(value)
        );
      });
    },
    searchCountries(value) {
      value = value.toLowerCase();
      this.allCountries = this.countries.filter((item) => {
        return item.name
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .includes(value);
      });
    },

    handleChange(data) {
      this.showCountry = data;
      this.countriesCode = this.countries;
    },
    handleChangeCountry(data) {
      this.handleDropdownVisibleChange(data);
      this.showCountries = data;
      this.allCountries = this.countries;
    },
    handleShowModal() {
      this.visible = true;
    },
    handleOk() {
      this.formRef
        .validateFields()
        .then(async () => {
          this.loading = true;
          const values = toRaw(this.formState);
          const formData = new FormData();
          if (this.imageFile) formData.append("logo", this.imageFile || "");
          formData.append("name", values.name);
          formData.append("phone", values.phone || "");
          if (values.phone) formData.append("code_phone", this.codePhone || "");
          formData.append("email", values.email || "");
          formData.append("country", values.countryCity || "");
          formData.append("type_industry", values.type_industry);
          formData.append("description", this.formState.description);
          formData.append("keywords", JSON.stringify(this.formState.keywords));
          await this.$store.dispatch("createNewEntity", formData);
          this.$emit("update");
          this.visible = false;
          this.selectedImage = false;
          this.$message.success(`Se ha creado la nueva empresa ”${this.formState.name}” `);
          this.resetFields();
        })
        .catch((error) => {
          this.$message.error("No se pudo crear la empresa");
          console.log(error);
        });
    },
    handleSelectedImagen(e) {
      this.selectedImage = e;
    },
    handleSelectedImagenEntity(e) {
      this.isEntity = e;
    },
    handleDropdownVisibleChange(open) {
      clearTimeout(this.dropdownCloseTimer);
      if (open) {
        this.isAnyDropdownOpen = true;
      } else {
        this.dropdownCloseTimer = setTimeout(() => {
          this.isAnyDropdownOpen = false;
        }, 100);
      }
    },
    preventScroll(e) {
      if (this.isAnyDropdownOpen) {
        if (e.target.closest('.ant-select-dropdown')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
  },
});
</script>

<style lang="sass" scoped>
.form
  display: block
  max-width: 450px
  margin: 0 auto

.label
  display: block
  margin-bottom: 8px

.ant-form-item
  margin-bottom: 12px

  .textarea
    position: relative
    border: 1px solid $gray-5
    width: 276px
    border-radius: 4px
    width: 100%

    &::placeholder
      color: $gray-6
    &:hover
      border: 1px solid $blue-5
    &:focus
      border: 1px solid $blue-5

  .counter
    position: absolute !important
    right: 12px
    bottom: 12px
    font-size: 12px
    color: $gray-6

.flag
  width: 20px
  margin-bottom: 2px
  margin-right: 4px

.button--create
  margin-top: 4px

.circle--title
  width: 120px

:deep(.ant-modal-body)
  padding: 24px 0

.country
  width: 105px
  white-space: nowrap
  text-overflow: ellipsis
  overflow: hidden

.info-section
  width: 450px
  text-align: justify
  color: $gray-8
  font-size: 12px
  font-style: italic
</style>
